import { ResponsiveCalendar, ResponsiveTimeRange } from '@nivo/calendar'
import moment from 'moment'
import { MomentInput } from 'moment'
import React, { useEffect, useState } from 'react'
import { useAppSelector } from '../../../store/hooks/hooks'
import './attendance.scss'


const AttendanceCalender = (props: any) => {
    const [data,setData] = useState<any>()
    const [from,setFrom] = useState<any>()
    const [to,setTo] = useState<any>()
    useEffect(() => {
        setData(props.data)
    },[])
    useEffect(() => {
        if(data){
            let dates = [...data]
            setFrom(
                dates.sort((a: any, b: any) => {
                    return new Date(moment(a.day).toDate()) > new Date(moment(b.day).toISOString()) ? 1 : -1
                })[0].day
            )
            let lastValue =   dates.sort((a: any, b: any) => {
                return new Date(moment(a.day).toDate()) > new Date(moment(b.day).toISOString()) ? 1 : -1
            })[data.length - 1]
            setTo(moment(lastValue.day).add(5,"months").format("YYYY-MM-DD").toString())
        }
    },[data])
    return (
        <div className='w-100 height-250-Mob'>
            <h3 className="attendanceTitle pt-3 px-3 w-100">Attendance</h3>
            <div className='attendanceChartStyle'>
                <ResponsiveTimeRange
                    data={props.data}
                    from={from}
                    to={to}
                    theme={{
                        background: "#23011f",
                        textColor: "#ffffff",
                        tooltip: {
                            container: {
                                color: "#ffff",
                                backgroundColor: "#000000"
                            },
                            chip: {
                                backgroundColor: "#000000"
                            }
                        }
                    }}
                    minValue={0}
                    maxValue={1}
                    emptyColor="#453a4480"
                    colors={['#f47560', '#97e3d5', '#61cdbb']}
                    margin={{ top: 40, right: 40, bottom: 100, left: 40 }}
                    dayBorderWidth={2}
                    dayBorderColor="#23011f"
                    tooltip={function (t) {
                        return (
                            <div style={{
                                borderRadius: "4px",
                                backgroundColor: "hsla(0, 0%, 20%, 0.9)",

                            }}>
                                <p style={{
                                    margin: "10px"
                                }}>{t.day} : {t.value === "1" ? "Present" : "Absent"}</p>
                            </div>
                        )
                    }}
                    legends={[
                        {
                            anchor: 'bottom-right',
                            direction: 'row',
                            justify: false,
                            itemCount: 2,
                            itemWidth: 42,
                            itemHeight: 36,
                            itemsSpacing: 14,
                            itemDirection: 'right-to-left',
                            translateX: -60,
                            translateY: -60,
                            symbolSize: 20,
                        }
                    ]}
                />
            </div>
        </div>
    )
}
export default AttendanceCalender